import axios from "axios";

export default axios.create({
    baseURL: "https://dev-ci.alaxione.fr/ajax",
    headers: {
        "Content-type": "application/json"
    }
});